import { get } from 'lodash';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { ResolverTag, TokenType } from '@swf/core/enums';
import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

interface Options {
  tokenType?: TokenType;
  query?: object;
}

const useResolver = (tag?: ResolverTag | string, options: Options = {}): string => {
  const resolverTags = useSelector(select.resolver.get);
  const brand = useSelector(select.site.getBrandName);
  const site = useSelector(select.site.getName);
  const { tokenType, query } = options;
  const {
    resolver: { fetchTag }
  } = useDispatch<Dispatch>();

  useEffect(() => {
    if (tag) {
      fetchTag({ tag, tokenType, query });
    }
  }, [fetchTag, tag, tokenType, query, site, brand]);

  return get(resolverTags, [tag || '', 'url'], '');
};

export default useResolver;
